import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { Language as WebIcon } from '@mui/icons-material';
import type { WebSourceReference } from '../hooks/useChat';

export interface WebSourceBadgeProps {
  source: WebSourceReference;
}

const labelFor = (source: WebSourceReference): string => {
  try {
    const host = new URL(source.url).hostname.replace(/^www\./, '');
    return host || source.title;
  } catch {
    return source.title;
  }
};

const WebSourceBadge: React.FC<WebSourceBadgeProps> = ({ source }) => {
  const handleClick = () => {
    window.open(source.url, '_blank', 'noopener,noreferrer');
  };

  const tooltip = source.title ? `${source.title} (${source.url})` : source.url;

  return (
    <Tooltip title={tooltip} enterDelay={200} arrow>
      <Chip
        icon={<WebIcon sx={{ fontSize: '0.875rem' }} />}
        label={labelFor(source)}
        size="small"
        variant="outlined"
        color="info"
        onClick={handleClick}
        sx={{
          maxWidth: 180,
          cursor: 'pointer',
          fontSize: '0.75rem',
          height: 24,
          '& .MuiChip-label': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            px: 0.5,
          },
          '& .MuiChip-icon': {
            ml: 0.5,
          },
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      />
    </Tooltip>
  );
};

export default WebSourceBadge;
